/* eslint-disable max-lines, import/no-default-export */

export type PossibleTypesResultData = {
  possibleTypes: {
    GidParam: ["SpreeLineItem"];
    Node: ["SpreeLineItem"];
  };
};
const result: PossibleTypesResultData = {
  possibleTypes: {
    GidParam: ["SpreeLineItem"],
    Node: ["SpreeLineItem"]
  }
};
export default result;
